module.exports = __webpack_public_path__ + "static/media/Jan'20Resume.cc2605c0.pdf";